import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space4 } = theme();

  return StyleSheet.create({
    container: {
      paddingVertical: space4,
    },
  });
};

export { style };
